import i18n from "@/locales"
const $t = i18n.global.t
const MenuList = [
    // {
    //     name: $t('l_Search'),
    //     icon: "search",
    //     routerPath: "/admin/search",
    //     expand: true,
    //     children: []
    // },
    {
        name: $t("l_Order_search"),
        icon: "travel_explore",
        routerPath: "/admin/search-all",
        expand: true,
        children: [],
    },
    // {
    //     name: $t('l_User'),
    //     icon: "group",
    //     routerPath: "/admin/user",
    //     expand: true,
    //     children: []
    // },
    // {
    //     name: $t('l_Recipient'),
    //     icon: "badge",
    //     routerPath: "/admin/ship",
    //     expand: true,
    //     children: []
    // },
    {
        name: $t("l_Send_push_message"),
        icon: "send",
        routerPath: "_454",
        expand: true,
        children: [
            {
                name: $t("l_By_category"),
                icon: "quiz",
                routerPath: "/admin/push/category",
                expand: true,
                children: [],
            },
            {
                name: $t("l_News"),
                icon: "quiz",
                routerPath: "/admin/push/filter",
                expand: true,
                children: [],
            },
            {
                name: $t("l_By_file"),
                icon: "quiz",
                routerPath: "/admin/push/file",
                expand: true,
                children: [],
            },
            {
                name: $t("l_New_station"),
                icon: "quiz",
                routerPath: "/admin/push/new-branch",
                expand: true,
                children: [],
            },
        ],
    },
    {
        name: $t("l_Statistics"),
        icon: "analytics",
        routerPath: "_225",
        expand: true,
        children: [
            {
                name: "Mastercard",
                icon: "credit_card",
                routerPath: "/admin/statistics/mastercard",
                expand: true,
                children: [],
            },
            {
                name: $t("l_Stories"),
                icon: "web_stories",
                routerPath: "/admin/statistics/stories-banner",
                expand: true,
                children: [],
            },
        ],
    },
    {
        name: $t("l_Promo_code"),
        icon: "loyalty",
        routerPath: "_229",
        expand: true,
        children: [
            {
                name: $t("l_Statistics"),
                routerPath: "/admin/referral-promo/promo-code",
                expand: true,
                children: [],
            },
            {
                name: $t("l_System_promo_code"),
                routerPath: "/admin/referral-promo/system",
                expand: true,
                children: [],
            },
            {
                name: "[v2] " + $t("l_System_promo_code"),
                routerPath: "/admin/promotion",
                expand: true,
                children: [],
            },
        ],
    },
    {
        name: $t("l_Reasons_for_account_deletion"),
        icon: "credit_card",
        routerPath: "/admin/deleted-accounts",
        expand: true,
        children: [],
    },
    // {
    //     name: $t('l_Feedback'),
    //     icon: "feedback",
    //     routerPath: "_232",
    //     expand: true,
    //     children: [
    //         {
    //             name: $t('l_List'),
    //             icon: "quiz",
    //             routerPath: "/admin/feedback",
    //             expand: true,
    //             children: []
    //         },
    //         {
    //             name: $t("l_Reason"),
    //             routerPath: "/admin/feedback/reason-status/list",
    //             expand: true,
    //             icon: "feedback",
    //             permissionTag: "__",
    //             children: [],

    //         },
    //         {
    //             name: $t("l_Result"),
    //             routerPath: "/admin/feedback/result-status/list",
    //             expand: true,
    //             icon: "feedback",
    //             permissionTag: "__",
    //             children: [],
    //         },
    //         {
    //             name: $t("l_Refund_account"),
    //             routerPath: "/admin/feedback/refound-account/list",
    //             expand: true,
    //             icon: "feedback",
    //             permissionTag: "__",
    //             children: [],
    //         },
    //     ]
    // },
    {
        name: "FAQ",
        icon: "quiz",
        routerPath: "_346364",
        expand: true,
        children: [
            {
                name: $t("l_Category"),
                icon: "quiz",
                routerPath: "/admin/faq/category",
                expand: true,
                children: [],
            },
            {
                name: $t("l_Article"),
                icon: "quiz",
                routerPath: "/admin/faq/article",
                expand: true,
                children: [],
            },
            {
                name: $t("l_Feedback"),
                icon: "quiz",
                routerPath: "/admin/faq/response",
                expand: true,
                children: [],
            },
        ],
    },
    {
        name: $t("l_Rate_question"),
        icon: "thumbs_up_down",
        routerPath: "/admin/question-rate",
        expand: false,
        children: [],
    },
    {
        name: "App",
        icon: "phone_iphone",
        routerPath: "/admin/app",
        expand: true,
        children: [
            {
                name: "(Home) " + $t("l_Home_banner"),
                icon: "",
                routerPath: "/admin/app/home-banner",
                expand: false,
                children: [],
            },
            {
                name: $t("l_Article"),
                icon: "",
                routerPath: "/admin/app/article",
                expand: false,
                children: [],
            },
            {
                name: $t("l_Order_status") + " (" + $t("l_Reception") + ")",
                icon: "",
                routerPath: "/admin/app/order-status",
                expand: false,
                children: [],
            },
            {
                name: $t("l_Order_status") + " (" + $t("l_Send") + ")",
                icon: "",
                routerPath: "/admin/app/order-status-send",
                expand: false,
                children: [],
            },
            {
                name: $t("l_App_version"),
                icon: "",
                routerPath: "/admin/app/version",
                expand: false,
                children: [],
            },
            {
                name: $t("l_Invite_list"),
                icon: "",
                routerPath: "/admin/app/invite",
                expand: false,
                children: [],
            },
            // end
            {
                name: "App custom info",
                icon: "",
                routerPath: "/admin/app/custom-info",
                expand: false,
                children: [],
            },
            {
                name: $t("l_Video_guide"),
                icon: "",
                routerPath: "/admin/app/video-guide",
                expand: false,
                children: [],
            },
            {
                name: $t("l_Story_feed"),
                icon: "",
                routerPath: "/admin/app/stories-group",
                expand: false,
                children: [],
            },
            {
                name: $t("l_Marketplace"),
                icon: "",
                routerPath: "/admin/app/marketplace",
                expand: false,
                children: [],
            },
            {
                name: $t("l_China_warehouse_address"),
                icon: "",
                routerPath: "/admin/app/china-warehouse-address",
                expand: false,
                children: [],
            },
            {
                name: $t("l_Push_category"),
                icon: "",
                routerPath: "/admin/app/push-category",
                expand: false,
                children: [],
            },
            {
                name: $t("l_Back_to_school"),
                icon: "",
                routerPath: "/admin/app/back-to-school",
                expand: false,
                children: [],
            },
            {
                name: $t("l_Services"),
                icon: "",
                routerPath: "/admin/app/service",
                expand: false,
                children: [],
            },
            {
                name: "App Deep Link",
                icon: "",
                routerPath: "/admin/app/deep-link",
                expand: false,
                children: [],
            },
        ],
    },
    {
        name: $t("l_Remote_config"),
        icon: "tune",
        routerPath: "_remote_config",
        expand: true,
        children: [
            {
                name: $t("l_Remote_config_info"),
                icon: "",
                routerPath: "/admin/app/remote-config/info",
                expand: false,
                children: [],
            },
            {
                name: $t("l_Remote_config_social"),
                icon: "",
                routerPath: "/admin/app/remote-config/social",
                expand: false,
                children: [],
            },
            {
                name: $t("l_Remote_config_legal"),
                icon: "",
                routerPath: "/admin/app/remote-config/legal",
                expand: false,
                children: [],
            },
            {
                name: $t("l_Remote_config_features"),
                icon: "",
                routerPath: "/admin/app/remote-config/features",
                expand: false,
                children: [],
            },
            {
                name: $t("l_Remote_config_devmode"),
                icon: "",
                routerPath: "/admin/app/remote-config/devmode",
                expand: false,
                children: [],
            },
            {
                name: $t("l_Remote_config_home_page_promo_icon"),
                icon: "",
                routerPath: "/admin/app/remote-config/home-page-promo-icon",
                expand: false,
                children: [],
            },
            {
                name: $t("l_Remote_config_custom_order"),
                icon: "",
                routerPath: "/admin/app/remote-config/custom-order",
                expand: false,
                children: [],
            },
            {
                name: $t("l_Feature_flags"),
                icon: "",
                routerPath: "/admin/app/remote-config/feature-flags",
                expand: false,
                children: [],
            },
            {
                name: $t("l_Control_groups"),
                icon: "",
                routerPath: "/admin/app/remote-config/control-groups",
                expand: false,
                children: [],
            },
        ],
    },
    {
        name: $t("l_Translation"),
        icon: "g_translate",
        routerPath: "/admin/settings/translate",
        permissionTag: "__",
        expand: false,
        children: [],
    },
    {
        name: $t("l_Settings"),
        icon: "settings",
        routerPath: "_9",
        permissionTag: "__",
        expand: true,
        children: [
            {
                name: "Sub status",
                icon: "",
                routerPath: "/admin/settings/sub-order-status",
                permissionTag: "__",
                expand: false,
                children: [],
            },
            {
                name: $t("l_Public_document"),
                icon: "",
                routerPath: "/admin/settings/public-document",
                permissionTag: "__",
                expand: false,
                children: [],
            },
        ],
    },
    {
        name: $t("l_Chinese_address"),
        icon: "content_copy",
        routerPath: "/admin/supervision/china-address-copy",
        expand: false,
        children: [],
    },
    {
        name: $t("l_VIP_client"),
        icon: "diamond",
        routerPath: "/admin/vip",
        expand: false,
        children: [],
    },
    {
        name: "Super",
        icon: "lock_person",
        routerPath: "__",
        permissionTag: "__",
        expand: true,
        isSuper: true,
        children: [
            {
                name: "Static file",
                icon: "",
                routerPath: "/admin/super/static-folder",
                permissionTag: "__",
                expand: false,
                children: [],
            },
            {
                name: $t("l_Employee_discount"),
                icon: "",
                routerPath: "/admin/staff-discount/list",
                permissionTag: "__",
                expand: false,
                children: [],
            },
        ],
    },
    {
        name: $t("l_Admin"),
        icon: "manage_accounts",
        routerPath: "/admin/account",
        expand: false,
        children: [],
        isSuper: true,
    },
]

export default MenuList
